import { useMutation } from '@tanstack/react-query';
import { publicProposalApi } from '@/api/commercial/public-proposal';

export function useAcceptProposal() {
  return useMutation({
    mutationFn: ({ token }: { token: string; declarationAccepted: true }) =>
      publicProposalApi.accept(token, true),
  });
}
